import axiosInstance from './axiosConfig';

export const getHistoricoDeAlteracoes = async () => {
    const response = await axiosInstance.get('/audit-log');
    return response?.data;
};
